import { Reducer, Dispatch } from 'react';
import { action, on, props, reducer, union } from 'ts-action';
import { Notification, NotificationStatusId, NotificationSummary } from '@packages/models/api';

export interface NotificationsState {
    notificationSummary: NotificationSummary;
    notifications: Notification[];
    notificationsFetched: boolean;
}

export const notificationsActions = {
    resetState: action('RESET_NOTIFICATIONS_STATE'),
    updateNotificationSummary: action(
        'UPDATE_NOTIFICATION_SUMMARY',
        props<{ notificationSummary: NotificationSummary }>()
    ),
    updateNotifications: action('UPDATE_NOTIFICATIONS', props<{ notifications: Notification[] }>()),
};

const actionsUnion = union(...Object.values(notificationsActions));
type NotificationsActions = typeof actionsUnion.actions;

export type NotificationsActionsDispatcher = Dispatch<NotificationsActions>;

export const initialState: NotificationsState = {
    notificationSummary: {
        [NotificationStatusId.New]: { count: 0, countDescription: '' },
        [NotificationStatusId.Read]: { count: 0, countDescription: '' },
        [NotificationStatusId.Unread]: { count: 0, countDescription: '' },
    },
    notifications: [],
    notificationsFetched: false,
};

export const notificationsReducer: Reducer<NotificationsState, NotificationsActions> = reducer(
    initialState,
    on(notificationsActions.resetState, () => {
        return { ...initialState };
    }),
    on(notificationsActions.updateNotificationSummary, (state, { notificationSummary }) => {
        return {
            ...state,
            notificationSummary: notificationSummary,
        };
    }),
    on(notificationsActions.updateNotifications, (state, { notifications }) => {
        return {
            ...state,
            notifications,
            notificationsFetched: true,
        };
    })
);
